import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  useToast,
} from '@chakra-ui/react';

const DoctorProfileModal = ({ isOpen, onClose, onSubmit, user }) => {
  const [doctorID, setDoctorID] = useState();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [status, setStatus] = useState('active');
  const [gender, setGender] = useState('M');
  const toast = useToast();

  useEffect(() => {
    if (user) {
      setDoctorID(user.id);
      setFirstName(user.first_name);
      setLastName(user.last_name);
      setStatus(user.status);
      setGender(user.gender);
    } else {
      setFirstName('');
      setLastName('');
      setStatus('');
      setGender('');
    }
  }, [user]);

  const handleSubmit = () => {
    if(firstName && lastName && gender && status){
        const userData = {
        doctor_id: doctorID,
        first_name: firstName,
        last_name: lastName,
        gender: gender,
        status: status,
        };

        onSubmit(userData);
        onClose();
    }
    else{
        toast({title: "กรุณากรอกข้อมูลให้ครบทั้งหมด", status: "warning", duration: 3000, isClosable: true,});
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{user ? 'แก้ไชช้อมูลแพทย์' : 'เพิ่มแพทย์'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>ชื่อ</FormLabel>
            <Input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>นามสกุล</FormLabel>
            <Input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>สถานะ</FormLabel>
            <Select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="">เลือกสถานะ</option>
              <option key="active" value="active">Active</option>
              <option key="inactive" value="inactive">Inactive</option>
            </Select>
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>Gender</FormLabel>
            <Select value={gender} onChange={(e) => setGender(e.target.value)}>
              <option value="">เลือกเพศ</option>
              <option key="M" value="M">ชาย</option>
              <option key="F" value="F">หญิง</option>
              <option key="not specified" value="not specified">ไม่ระบุ</option>
            </Select>
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            ยกเลิก
          </Button>
          <Button colorScheme="green" onClick={handleSubmit}>
            บันทึกข้อมูล
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DoctorProfileModal;
